import loanFormModel from '../../../components/loan_application/form_models/loanFormModel';
import { ValidationSchema } from '../../../validations/interfaces';
import { Validation } from '../../../validations/Validation';
import * as Yup from 'yup';
const {
  formField: { outstandingLoanType, onSystemProperty },
} = loanFormModel;

export class MortgageLoanTypeValidation implements ValidationSchema {
  public name = outstandingLoanType.name;
  public label = outstandingLoanType.label;
  public dependsOn: string[] = [onSystemProperty.name];
  public type = 'string';
  public required = {
    message: outstandingLoanType.requiredErrorMsg,
    value: outstandingLoanType.required,
  };
  public nullable = true;

  public when(
    onSystemProperty: string,
    schema: Yup.StringSchema,
    context: any
  ) {
    if (onSystemProperty === 'Yes') {
      return schema.required(outstandingLoanType.requiredErrorMsg);
    }
    return schema;
  }
}
export default new Validation(new MortgageLoanTypeValidation());
